export default __webpack_public_path__ + "static/media/search-icon.b0af3774.svg";